import { FormManager } from 'react-form-state-manager';
import { useRef } from 'react';

import { DebouncedInputProps } from '../../common/UI/DebouncedInput';
import UI from '../../common/UI';

interface WebsiteInputProps extends Omit<DebouncedInputProps, 'form'> {
  form: FormManager;
  formKey: string;
}

const scheme = 'https://';

const WebsiteInput = ({ form, formKey, ...props }: WebsiteInputProps) => {
  const inputRef = useRef<HTMLInputElement>();

  const addScheme = () => {
    const websiteUrl = form.get(formKey) || '';

    if (websiteUrl.trim() && !websiteUrl.includes('://')) {
      const newUrl = `${scheme}${websiteUrl}`;

      form.set(formKey, newUrl);

      if (inputRef.current) {
        inputRef.current.value = newUrl;
      }
    }
  };

  return (
    <UI.DebouncedInput
      {...form.text(formKey)}
      onBlur={addScheme}
      ref={inputRef}
      placeholder={scheme}
      {...props}
    />
  );
};

export default WebsiteInput;
